import { Tabs, TabsContent, TabsList, TabsTrigger } from '@radix-ui/react-tabs'
import React from 'react'

import { type IconProp } from 'slab'

export type AllowanceTab = {
  id: 'allowances' | 'employees' | 'details' | 'plans' | 'recommended' | 'custom'
  label: string
  icon?: IconProp
  content: React.ReactNode
  hidden?: boolean
}

export type AllowanceTabsProps = {
  defaultValue: string
  tabs: AllowanceTab[]
  onValueChange?: (value: string) => void
}

function AllowanceTabs ({ defaultValue, tabs, onValueChange }: AllowanceTabsProps) {
  const visibleTabs = tabs.filter(tab => !tab.hidden)

  return (
    <Tabs defaultValue={defaultValue} onValueChange={onValueChange}>
      <TabsList className='flex flex-row gap-4 border-b border-gray-200 px-6'>
        {visibleTabs.map(tab => (
          <TabsTrigger
            key={tab.id}
            value={tab.id}
            className='text-gray-800 body data-[state=active]:body-bold data-[state=active]:border-b-2 border-gray-800'
          >
            <div className='flex flex-row items-center gap-1 p-2'>
              {tab.icon && <tab.icon size={16} />}
              <span>
                {tab.label}
              </span>
            </div>
          </TabsTrigger>
        ))}
      </TabsList>
      {visibleTabs.map(tab => (
        <TabsContent className='p-6' key={tab.id} value={tab.id}>
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  )
}

export default AllowanceTabs
